var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"meeting-header"},[_c('h2',[_vm._v(_vm._s(_vm.state.meetingData.event.title))]),_c('p',[_vm._v(_vm._s(_vm.state.meetingData.event.where))])])])}
var staticRenderFns = []

export { render, staticRenderFns }